import { initializeSentry } from './sentry-setup';
import { initializeMixpanel } from './mixpanel-setup';
import { createLogger } from './logger';
import type { LoggingConfig } from './types';
import type { Logger } from './types';

/**
 * Initialize all logging and monitoring systems
 * Call this once at application startup
 *
 * @param config - Configuration for logging systems
 * @returns The logger instance
 *
 * @example
 * ```typescript
 * import { initializeLogging } from '@vitvio/logging';
 *
 * const logger = initializeLogging({
 *   environment: 'production',
 *   sentryDsn: 'https://...',
 *   mixpanelToken: 'abc123',
 * });
 *
 * logger.info('Application started');
 * ```
 */
export function initializeLogging(config: LoggingConfig): Logger {
  // TODO: remove
  // eslint-disable-next-line no-console
  console.info('Initializing logging', config);

  // Initialize Sentry first
  initializeSentry({
    dsn: config.sentryDsn,
    environment: config.environment,
    tracesSampleRate: config.sentryTracesSampleRate,
  });

  // Initialize Mixpanel
  initializeMixpanel({
    token: config.mixpanelToken,
    environment: config.environment,
  });

  // Create and return logger
  const logger = createLogger({
    environment: config.environment,
  });

  return logger;
}
